// Code generated by "typescripter -type=BlackoutScope -linecomment -output=../../portal/src/enums/blackoutscopeenum.ts"; DO NOT EDIT.

export enum BlackoutScopeEnum {
  BlackoutScopeSeries = 'series',
  BlackoutScopeImage = 'image',
  BlackoutScopeMatchingDimension = 'matching_dimension',
}
